// Microsoft OAuth Configuration
export const MICROSOFT_OAUTH_CONFIG = {
  // Replace with your actual Microsoft OAuth Client ID
  // You can get this from Azure Portal > App Registrations
  clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || 'your-microsoft-client-id-here',
  
  // Scopes for Microsoft registration - need User.Read to access Graph API
  scope: 'openid profile email User.Read',
  
  // Redirect URI (should match what you configure in Azure Portal)
  redirectUri: `${window.location.origin}${process.env.PUBLIC_URL}/microsoft-oauth-callback.html`,
  
  // Tenant ID (optional, use 'common' for multi-tenant apps)
  tenantId: process.env.REACT_APP_MICROSOFT_TENANT_ID || 'common',
};

// Microsoft OAuth endpoints
export const MICROSOFT_OAUTH_ENDPOINTS = {
  authorization: `https://login.microsoftonline.com/${MICROSOFT_OAUTH_CONFIG.tenantId}/oauth2/v2.0/authorize`,
  token: `https://login.microsoftonline.com/${MICROSOFT_OAUTH_CONFIG.tenantId}/oauth2/v2.0/token`,
  userInfo: 'https://graph.microsoft.com/v1.0/me',
};

// Helper function to validate configuration
export const validateMicrosoftOAuthConfig = (): boolean => {
  return !!(MICROSOFT_OAUTH_CONFIG.clientId && 
           MICROSOFT_OAUTH_CONFIG.clientId !== 'your-microsoft-client-id-here');
};

// Helper function to generate Microsoft OAuth URL
export const generateMicrosoftOAuthUrl = (): string => {
  // Validate that we have a proper client ID
  if (!validateMicrosoftOAuthConfig()) {
    throw new Error('Microsoft OAuth Client ID is not configured. Please set REACT_APP_MICROSOFT_CLIENT_ID in your .env file.');
  }

  const params = new URLSearchParams({
    client_id: MICROSOFT_OAUTH_CONFIG.clientId,
    redirect_uri: MICROSOFT_OAUTH_CONFIG.redirectUri,
    response_type: 'code',
    scope: MICROSOFT_OAUTH_CONFIG.scope,
    response_mode: 'query',
  });

  return `${MICROSOFT_OAUTH_ENDPOINTS.authorization}?${params.toString()}`;
};



const generateRandomString = (length = 32): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const arr = new Uint8Array(length);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (n) => chars[n % chars.length]).join('');
};

// Helper function to generate Microsoft OAuth URL for popup flow
export const generateMicrosoftOAuthPopupUrl = (): { url: string; state: string } => {
  if (!validateMicrosoftOAuthConfig()) {
    throw new Error('Microsoft OAuth Client ID is not configured. Please set REACT_APP_MICROSOFT_CLIENT_ID in your .env file.');
  }

  const state = generateRandomString(32);

  const params = new URLSearchParams({
    client_id: MICROSOFT_OAUTH_CONFIG.clientId,
    redirect_uri: MICROSOFT_OAUTH_CONFIG.redirectUri,
    response_type: 'token',
    scope: MICROSOFT_OAUTH_CONFIG.scope,
    response_mode: 'fragment',
    state,
  });

  return { url: `${MICROSOFT_OAUTH_ENDPOINTS.authorization}?${params.toString()}`, state };
};

// Helper function to get Microsoft OAuth configuration info
export const getMicrosoftOAuthConfigInfo = () => {
  return {
    isConfigured: validateMicrosoftOAuthConfig(),
    clientId: MICROSOFT_OAUTH_CONFIG.clientId,
    scope: MICROSOFT_OAUTH_CONFIG.scope,
    redirectUri: MICROSOFT_OAUTH_CONFIG.redirectUri,
    tenantId: MICROSOFT_OAUTH_CONFIG.tenantId,
    endpoints: MICROSOFT_OAUTH_ENDPOINTS
  };
}; 